/**
 * Respondent-facing "how to complete this assessment" copy, shown on the post-login
 * Instructions screen before anyone starts answering. This is the exact text provided
 * by the review team (2026-08-17) — do not paraphrase or reformat without checking with
 * them first, since consistency with their reviewed/approved version was the whole point.
 */

export const INSTRUCTIONS_TITLE = 'Welcome to the Data & Analytics Maturity Assessment Survey';

export const PURPOSE_TEXT =
  'This assessment helps evaluate how effectively Data, Analytics, and AI are used across your organization to achieve business outcomes. It identifies current strengths and opportunities to improve data-driven decision-making.';

export const WHY_PARTICIPATE_TEXT =
  "Your input is critical because you work directly with data or rely on data for making decisions. Whether you're an analyst, a power user, a manager, or a leader, your perspective will help build a comprehensive view of your department's data maturity.";

export const WHO_SHOULD_COMPLETE: string[] = [
  'Analysts and power users who work closely with data on a daily basis',
  'Managers and directors who make operational and tactical decisions',
  'Strategic decision-makers who rely on data insights for long-term planning',
];

export const HOW_TO_COMPLETE_BASE: string[] = [
  'Read each question carefully. Each question assesses a specific aspect of how data is used in your department.',
  'For each question, select the response that best describes your current state using the 5-point Likert scale.',
  'Feel free to skip a question (i.e., unanswered) if you do not have insights into the specific area. For example, if you are part of the Finance budgeting team and asked questions on areas you do not have visibility, kindly skip the question.',
  'Though you may be part of a sub-function within your team, having visibility into your area only, you are representing your department as a whole.',
];

export const LIKERT_SCALE: { level: number; tier: string; description: string }[] = [
  { level: 1, tier: 'Initial / Ad Hoc', description: 'Processes are informal, reactive, and not standardized. No consistent use of data.' },
  { level: 2, tier: 'Repeatable / Developing', description: 'Basic capabilities exist; data is used inconsistently or manually. Possibly limited to certain groups or at experimentation stage.' },
  { level: 3, tier: 'Defined / Functional Excellence', description: 'Processes are well-defined and repeatable in some areas. Data is used effectively within silos.' },
  { level: 4, tier: 'Managed / Enterprise Integrated', description: 'Data and analytics are standardized, integrated across functions, and actively managed at enterprise level.' },
  { level: 5, tier: 'Optimization / Industry Best', description: 'Data is fully embedded, automated, and drives strategic, AI-powered decision-making. Well optimized and transformational.' },
];

export const RESPONSE_TIPS: string[] = [
  'Be honest and objective. This is not an evaluation of individual performance.',
  "If you're unsure about a question, consult with colleagues or select the option that most closely reflects your experience/observation.",
  'Use the comment box to provide additional context or examples if you feel that is critical.',
];
